let CompanyName = 'BioRetis GmbH';
let AppTitleTemplate = 'BioRetis - ICAP';

export {
    CompanyName,
    AppTitleTemplate,
}